import { useState } from 'react';
import { Card, Col } from 'reactstrap'
import { Image } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Service'
import ProfileDetail from './ProfileDetail'
import { useAuth } from '../../../../../hooks/useAuth'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Profile = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [imageError, setImageError] = useState(false);

  // Obtener foto del usuario o usar imagen por defecto
  const defaultImage = dynamicImage("user/7.jpg");
  const userPhoto = (user?.photo_url && !imageError) ? user.photo_url : defaultImage;

  // Manejar error de carga de imagen
  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Col sm="12">
      <Card className="hovercard text-center">
        <div className="cardheader" />
        <div className="user-image">
          <div className="avatar">
            <img
              src={userPhoto}
              alt={user?.name || "profile"}
              onError={handleImageError}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="icon-wrapper">
            <Link to={`${process.env.PUBLIC_URL}/users/useredit`}>
              <i className="icofont icofont-pencil-alt-5" title={t("Editar perfil")}/>
            </Link>
          </div>
        </div>
        <ProfileDetail />
      </Card>
    </Col>
  )
}

export default Profile